export const GET_COMMON_PRODUCTS = 'GET_COMMON_PRODUCTS';
export const GET_COMMON_PRODUCT = 'GET_COMMON_PRODUCT';
export const FLAG_GETTING_COMMON_PRODUCTS = 'FLAG_GETTING_COMMON_PRODUCTS';
export const FLAG_COMMON_PRODUCT_ACTIVITY = 'FLAG_COMMON_PRODUCT_ACTIVITY';
export const CLEAR_COMMON_PRODUCT = 'CLEAR_COMMON_PRODUCT';
export const CLEAR_COMMON_PRODUCTS = 'CLEAR_COMMON_PRODUCTS';
export const GET_COMMON_PRODUCT_PRICE = 'GET_COMMON_PRODUCT_PRICE';